import _ from 'lodash'
import { twMerge } from 'tailwind-merge'

const variantStyles = {
  primary: 'btn-primary',
  secondary: 'btn-secondary',
  outline: 'btn-outline',
  transparent: 'btn-transparent',
}

type ButtonProps = {
  variant?: keyof typeof variantStyles
  working?: boolean
} & (React.ComponentPropsWithoutRef<'button'>)

export function Button({ variant = 'primary', className, children, ...props }: ButtonProps) {
  className = twMerge(
    'transition duration-300 overflow-hidden text-sm/6 font-medium dark:font-normal rounded px-3 h-10 truncate',
    variantStyles[variant],
    className,
  )

  return (
    <button type='button' className={className} {..._.omit(props, 'working')} disabled={props.disabled || props?.working}>
      <span className='flex items-center justify-center'>
        {
          props?.working &&
          <svg className="animate-spin -ml-1 mr-3 h-5 w-5" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
            <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
            <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
          </svg>
        }
        {children}
      </span>
    </button>
  )
}
